import { keepPreviousData, useQuery } from "@tanstack/react-query";
import { projectsApi } from "@/api/projects";
import { queryKeys } from "@/lib/query-keys";

export function useProjects(page = 1) {

    return useQuery({
        queryKey: [...queryKeys.projects.list(), page],
        queryFn: () => projectsApi.list({ page }),
        placeholderData: keepPreviousData,
    });
}

export function useProject(id: string | undefined) {

    return useQuery({
        queryKey: id ? queryKeys.projects.detail(id) : ["projects", "detail", "_disabled_"],
        queryFn: () => projectsApi.get(id!),
        enabled: id !== undefined,
    });
}
